/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import GrantedAuthority from './GrantedAuthority';

/**
 * The Person model module.
 * @module model/Person
 * @version v0
 */
export default class Person {
  /**
   * Constructs a new <code>Person</code>.
   * @alias module:model/Person
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>Person</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Person} obj Optional instance to populate.
   * @return {module:model/Person} The populated <code>Person</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Person();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('oid'))
        obj.oid = ApiClient.convertToType(data['oid'], 'String');
      if (data.hasOwnProperty('accountId'))
        obj.accountId = ApiClient.convertToType(data['accountId'], 'String');
      if (data.hasOwnProperty('email'))
        obj.email = ApiClient.convertToType(data['email'], 'String');
      if (data.hasOwnProperty('password'))
        obj.password = ApiClient.convertToType(data['password'], 'String');
      if (data.hasOwnProperty('firstname'))
        obj.firstname = ApiClient.convertToType(data['firstname'], 'String');
      if (data.hasOwnProperty('lastname'))
        obj.lastname = ApiClient.convertToType(data['lastname'], 'String');
      if (data.hasOwnProperty('dateAdded'))
        obj.dateAdded = ApiClient.convertToType(data['dateAdded'], 'Number');
      if (data.hasOwnProperty('datePasswordLastChanged'))
        obj.datePasswordLastChanged = ApiClient.convertToType(data['datePasswordLastChanged'], 'Number');
      if (data.hasOwnProperty('permissions'))
        obj.permissions = ApiClient.convertToType(data['permissions'], 'String');
      if (data.hasOwnProperty('dateFormat'))
        obj.dateFormat = ApiClient.convertToType(data['dateFormat'], 'String');
      if (data.hasOwnProperty('authorities'))
        obj.authorities = ApiClient.convertToType(data['authorities'], [GrantedAuthority]);
      if (data.hasOwnProperty('username'))
        obj.username = ApiClient.convertToType(data['username'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('accountNonExpired'))
        obj.accountNonExpired = ApiClient.convertToType(data['accountNonExpired'], 'Boolean');
      if (data.hasOwnProperty('accountNonLocked'))
        obj.accountNonLocked = ApiClient.convertToType(data['accountNonLocked'], 'Boolean');
      if (data.hasOwnProperty('credentialsNonExpired'))
        obj.credentialsNonExpired = ApiClient.convertToType(data['credentialsNonExpired'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
Person.prototype.id = undefined;

/**
 * @member {String} oid
 */
Person.prototype.oid = undefined;

/**
 * @member {String} accountId
 */
Person.prototype.accountId = undefined;

/**
 * @member {String} email
 */
Person.prototype.email = undefined;

/**
 * @member {String} password
 */
Person.prototype.password = undefined;

/**
 * @member {String} firstname
 */
Person.prototype.firstname = undefined;

/**
 * @member {String} lastname
 */
Person.prototype.lastname = undefined;

/**
 * @member {Number} dateAdded
 */
Person.prototype.dateAdded = undefined;

/**
 * @member {Number} datePasswordLastChanged
 */
Person.prototype.datePasswordLastChanged = undefined;

/**
 * @member {String} permissions
 */
Person.prototype.permissions = undefined;

/**
 * @member {String} dateFormat
 */
Person.prototype.dateFormat = undefined;

/**
 * @member {Array.<module:model/GrantedAuthority>} authorities
 */
Person.prototype.authorities = undefined;

/**
 * @member {String} username
 */
Person.prototype.username = undefined;

/**
 * @member {Boolean} enabled
 */
Person.prototype.enabled = undefined;

/**
 * @member {Boolean} accountNonExpired
 */
Person.prototype.accountNonExpired = undefined;

/**
 * @member {Boolean} accountNonLocked
 */
Person.prototype.accountNonLocked = undefined;

/**
 * @member {Boolean} credentialsNonExpired
 */
Person.prototype.credentialsNonExpired = undefined;

